import React from 'react'
import { ActionField } from '../../components/custom'
import { ListBulkActions } from '../../components'
import {
  List,
  Datagrid,
  TextField,
  TextInput,
  Filter,
  FunctionField,
  ArrayField,
  SingleFieldList,
  SelectInput,
} from 'react-admin'

import { ROLE_ADMIN } from '../../utils/constants'
import { formatGender, formatSportKind, formatRole } from '../utils'
import {
  RolesOptions,
  SportKindsOptions,
  GendersOptions,
} from '../utils/helpers'

const UserFilters = (props) => (
  <Filter {...props}>
    <SelectInput label='Роль' source='roles' choices={RolesOptions} />
    <TextInput label='ФИО' source='fullName' />
    <SelectInput label='Пол' source='gender' choices={GendersOptions} />
    <TextInput label='E-mail' source='email' />
    <TextInput source='phone' label='Номер телефона' />
    <TextInput source='city' label='Город' />
    <SelectInput
      label='Вид спорта'
      source='sportKind'
      choices={SportKindsOptions}
    />
  </Filter>
)

const ListUser = (props) => {
  return (
    <List
      {...props}
      bulkActionButtons={
        props.permissions === ROLE_ADMIN ? <ListBulkActions /> : false
      }
      title='Пользователи'
      exporter={false}
      filters={<UserFilters />}
    >
      <Datagrid rowClick='show'>
        <ArrayField source='roles' label='Роль'>
          <SingleFieldList linkType={false}>
            <FunctionField render={(role) => formatRole(role)} />
          </SingleFieldList>
        </ArrayField>
        <TextField source='fullName' label='ФИО' />
        <FunctionField
          label='Пол'
          render={(record) => formatGender(record.gender)}
        />
        <TextField source='email' label='Эл. Почта' />
        <TextField source='phone' label='Номер телефона' />
        <TextField source='city.name' label='Город' />
        <FunctionField
          label='Вид спорта'
          render={(record) => formatSportKind(record.sportKind)}
        />
        {props.permissions === ROLE_ADMIN ? (
          <ActionField label='Действия' />
        ) : null}
      </Datagrid>
    </List>
  )
}

export default ListUser

// Фильтры по полям: ФИО(текстовый поиск), Роль(выбор из списка), Город(Текстовый поиск)
